<script setup lang="ts">
const { t } = useI18n()
const localePath = useLocalePath()
const { hasConsented, acceptAll, rejectAll } = useCookieConsent()

const showBanner = ref(false)
const showPreferences = ref(false)

onMounted(() => {
  if (!hasConsented.value) {
    showBanner.value = true
  }
})

function handleAcceptAll() {
  acceptAll()
  showBanner.value = false
}

function handleRejectAll() {
  rejectAll()
  showBanner.value = false
}

function openPreferences() {
  showPreferences.value = true
}

// Close banner when preferences are saved
watch(hasConsented, (val) => {
  if (val) showBanner.value = false
})
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="showBanner"
      class="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6"
    >
      <div class="max-w-xl mx-auto bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 p-5 sm:p-6">
        <p class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
          {{ t('cookieBanner.description') }}
          <NuxtLink
            :to="localePath('/p/cookie-policy')"
            class="font-semibold underline underline-offset-2 text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400"
          >
            {{ t('cookieBanner.policyLink') }}
          </NuxtLink>
          {{ t('cookieBanner.or') }}
          <button
            class="font-semibold underline underline-offset-2 text-gray-900 dark:text-white hover:text-brand-600 dark:hover:text-brand-400"
            @click="openPreferences"
          >
            {{ t('cookieBanner.manageLink') }}
          </button>.
        </p>
        <div class="flex items-center gap-3 mt-4">
          <button
            class="flex-1 px-5 py-2.5 text-sm font-semibold rounded-xl bg-brand-600 text-white hover:bg-brand-700 transition-colors"
            @click="handleAcceptAll"
          >
            {{ t('cookieBanner.acceptAll') }}
          </button>
          <button
            class="flex-1 px-5 py-2.5 text-sm font-semibold rounded-xl bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
            @click="handleRejectAll"
          >
            {{ t('cookieBanner.rejectAll') }}
          </button>
        </div>
      </div>
    </div>
  </Transition>

  <CookiePreferences v-model="showPreferences" />
</template>
